/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { MySQLInstrumentation } from './instrumentation';
export type { MySQLInstrumentationConfig } from './types';
